<h3>Notification Options</h3>
<luna-select placeholder="Notification Groups" multiple="true" [lunaModel]="data.configuration.groups" (lunaModelChange)="setGroups($event)">
  @for (item of groups; track item) {
    <option [lunaValue]="item">{{item.displayName}}</option>
  }
</luna-select>
<luna-select placeholder="Notification Level" [(lunaModel)]="data.configuration.level">
  @for (item of notificationLevels; track item) {
    <option [lunaValue]="item">{{item}}</option>
  }
</luna-select>
<luna-select placeholder="Notification Type" [(lunaModel)]="data.configuration.type">
  @for (item of notificationTypes | async; track item) {
    <option [lunaValue]="item.value">{{item.displayName}}</option>
  }
</luna-select>
@if (hasExternalGroup) {
  <rules-editor placeholder="External Organization Id" [rule]="data.configuration.targetOrganization" (updateRule)="data.configuration.targetOrganization = $event"></rules-editor>
}
<rules-editor placeholder="Description" type="Description" [rule]="data.configuration.description" (updateRule)="data.configuration.description = $event"></rules-editor>
<rules-editor placeholder="Redirection Url" type="Redirection Url" [rule]="data.configuration.redirectUrl" (updateRule)="data.configuration.redirectUrl = $event"></rules-editor>
<rules-editor placeholder="Target Flow Id" type="Target Flow Id" [rule]="data.configuration.flowId" (updateRule)="data.configuration.flowId = $event"></rules-editor>
<rules-editor placeholder="Target Work Order Id" type="Target Work Order Id" [rule]="data.configuration.workItemId" (updateRule)="data.configuration.workItemId = $event"></rules-editor>